const reducerPaths = {
  auth: "auth",
  sellerApi: "sellerApi",
  alertDialog: "alertDialog",
  myGarage: "myGarage",
  sellMyCarDashboard: "sellMyCarDashboard",
  sidebar: "sidebar",
  liveAuction: "liveAuction",
  carsInNegotiation: "carsInNegotiation",
  signinApi: "signinApi",
  vehicleApi: "vehicleApi",
  myGarageApi: "myGarageApi",
  buyNowApi: "buyNowApi",
  liveAuctionApi: "liveAuctionApi",
  carEstimateSlice: "carEstimateSlice",
  carEstimateApi: "carEstimateApi",
  upcomingCarsApi: "upcomingCarsApi",
  carDetailsApi: "carDetailsApi",
  carsInNegotiationApi: "carsInNegotiationApi",
  contactUsApi: "contactUsApi",
  geographyApi: "geographyApi",
  paypalApi: "paypalApi",
  carfaxApi: "carfaxApi",
  myOrdersApi: "myOrdersApi",
  rejectedCarsApi: "rejectedCarsApi",
  dashboardPaginationFiltersApi: "dashboardPaginationFiltersApi",
  paymentsApi: "paymentsApi"
};

export { reducerPaths };
